import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
const RoleBasedAccessControlHubRouteComponent = LoadablePaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-RoleBasedAccessControlHubRoute" */ './RoleBasedAccessControlHubRouteComponent.tsx'
		),
});

export const RoleBasedAccessControlHubRoute = () => {
	return <RoleBasedAccessControlHubRouteComponent />;
};

RoleBasedAccessControlHubRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const { name } = routeMatch;

	return {
		Screen: {
			screenEvent: {
				name: 'roleBasedAccessControlHubScreen',
			},
			pageState: { routeName: name },
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
